import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

export const RatingWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
  @media (${breakpoint.mdMin}) {
    justify-content: flex-start;
  }
`;
